<script setup>
import { url } from '@/config/urls';
import router from '@/router/index.js';
import { onMounted, onUnmounted } from 'vue';

const emit = defineEmits(['hidden']);

let modalEl = null;

const handleModalHidden = () => {
  if (document.activeElement && modalEl.contains(document.activeElement)) {
    document.activeElement.blur();
  }
}

const props = defineProps({
  screenId: {
    type: String,
    required: true
  },
  orderSearchPageUrl: {
    type: String,
    default: url.page.orderSearch
  },
  orderCartPageUrl: {
    type: String,
    default: url.page.orderCart
  }
});

const goToOrderSearch = () => {
  router.push(props.orderSearchPageUrl);
}

const goToOrderCart = () => {
  const modal = document.getElementById('addToCartCompleteModal');
  const bsModal = bootstrap.Modal.getInstance(modal);
  bsModal?.hide();

  router.push(props.orderCartPageUrl);
}

onMounted(() => {
  modalEl = document.getElementById('addToCartCompleteModal');
  if (modalEl) {
    modalEl.addEventListener('hide.bs.modal', handleModalHidden);
    modalEl.addEventListener('hidden.bs.modal', handleModalHidden);
  }
})

onUnmounted(() => {
  if(modalEl) {
    modalEl.addEventListener('hide.bs.modal', handleModalHidden);
    modalEl.addEventListener('hidden.bs.modal', handleModalHidden);
  }
})

</script>

<template>
  <div class="modal com_modal2 fade" id="addToCartCompleteModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_c_check1.png" alt="" class="icon_c_check1">
          <h3 class="com_fs18 com_strong1 com_center1">商品をカートに追加しました</h3>
          <p class="com_fs12 com_center1 com_color3 com_mgb0">取扱中止品はカートにいれることができません。ご了承ください。</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1 wd1" v-if="props.screenId === 'OrderSearch'" data-bs-dismiss="modal">商品選択を続ける</button>
          <button type="button" class="btn com_btn1 wd1" v-else-if="props.screenId === 'OrderHistory'" data-bs-dismiss="modal">発注履歴に戻る</button>
          <button type="button" class="btn com_btn1 wd1" v-else-if="props.screenId === 'OrderFavoriteDetail'" data-bs-dismiss="modal">お気に入りに戻る</button>
          <button type="button" class="btn com_btn1 wd1" v-else @click="goToOrderSearch">発注TOPに戻る</button>
          <button type="button" class="btn com_btn1 wd1" @click="goToOrderCart">カートへ移動</button>
        </div>
      </div>
    </div>
  </div>
</template>